import { render, staticRenderFns } from "./ButtonGroupTabs.vue?vue&type=template&id=79154ed3&scoped=true"
import script from "./ButtonGroupTabs.vue?vue&type=script&lang=js"
export * from "./ButtonGroupTabs.vue?vue&type=script&lang=js"
import style0 from "./ButtonGroupTabs.vue?vue&type=style&index=0&id=79154ed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79154ed3",
  null
  
)

export default component.exports